import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Carousel } from "react-responsive-carousel";
import axios from "axios";
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  EmailIcon,
  FacebookMessengerIcon,
  TelegramIcon,
  ViberIcon,
  WhatsappIcon,
} from "react-share";

function MediumPoslednjiPozdrav({ post, modalIsOpen }) {
  const [imageSrc, setImageSrc] = useState(require("../assets/candle.png"));
  let userRole = localStorage.getItem("userRole");
  const [counter, setCounter] = useState(post.counter);
  const handleCandleClick = () => {
    // Toggle between two image sources
    if (imageSrc === require("../assets/candle.png")) {
      setImageSrc(require("../assets/candleColor.png"));
    } else {
      setImageSrc(require("../assets/candle.png"));
    }
    increaseCounter();
  };

  const increaseCounter = async () => {
    try {
      setCounter(post.counter + 1);
      await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}/counter/up/`,
        {}
      );
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };
  if (!post) {
    return <div>Loading...</div>;
  }
  const deletePosts = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.delete(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const modalStyle = {
    border: "2px solid black",
    backgroundColor: "white",
    marginTop: "20px",
    minHeight: "650px",
  };
  return (
    <Container
      data-aos={"fade-up"}
      className="post"
      id={modalIsOpen ? "pp-md-open" : "pp-md"}
      style={modalIsOpen ? { ...modalStyle, height: "auto" } : modalStyle}
    >
      <Row>
        <p
          style={{
            fontStyle: "italic",
            border: "none",
            borderTop: "none",
            textAlign: "right",
            backgroundColor: "white",
            color: "gray",
          }}
        >
          {post.type === "poslednji_pozdrav" ? "poslednji pozdrav" : post.type}
        </p>
      </Row>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "55vh",
        }}
      >
        <Row style={{ fontSize: "medium" }}>
          <p style={{ textAlign: "center", paddingBottom: "1%" }}>
            {post.text_top}
          </p>
        </Row>
        <Row style={{ paddingTop: "3%", justifyContent: "center" }}>
          {/*    <Col className="d-flex justify-content-center">
            {modalIsOpen && (
              <img
                id="umrlica-icon"
                style={{
                  height: "40px",
                  width: "40px",

                  border: "none",
                }}
                src={post.icon}
                alt="x"
              />
            )}
          </Col> */}
        </Row>
        <Row>
          <Col className=" justify-content-around"></Col>
          <Col className="d-flex justify-content-around">
            {post.images.length !== 0 && (
              <Carousel
                showThumbs={false}
                showArrows={false}
                infiniteLoop={true}
                autoPlay={true}
                interval={2500}
              >
                {post.images
                  .reduce((p, c) => p + c)
                  .split(",")
                  .map((imagePath, index) => (
                    <div className="d-flex justify-content-center" key={index}>
                      <div
                        style={{
                          width: "120px",
                          height: "150px",
                          border: "3px solid black",
                          background: `url(https://radojicictijanaa.pythonanywhere.com/${imagePath})`,
                          backgroundSize: "cover",
                          backgroundPosition: "50% 50%",
                        }}
                      ></div>
                    </div>
                  ))}
              </Carousel>
            )}
          </Col>
          <Col className="d-flex justify-content-around"></Col>
        </Row>
        <Row style={{ paddingTop: "1%" }}>
          <p style={{ textAlign: "center", fontSize: "1.4rem" }}>{post.name}</p>
        </Row>
        <Row
          style={{ paddingTop: "5%", height: "auto", justifyContent: "center" }}
        >
          <p
            className="main-text"
            style={{
              marginTop: "auto",
              marginBottom: "auto",
              textAlign: "center",
              paddingLeft: "22px",
              paddingRight: "22px",
            }}
          >
            {post.main_text}
          </p>
        </Row>
      </div>
      {modalIsOpen && (
        <Row>
          <span style={{ textAlign: "center" }}>Upali svijeću</span>
        </Row>
      )}
      {modalIsOpen && (
        <Row>
          {" "}
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              alignItems: "center",
              borderRadius: "100%",
            }}
            onClick={handleCandleClick}
          >
            <img src={imageSrc} alt="Image" />
          </button>
        </Row>
      )}
      {modalIsOpen && (
        <Row>
          {" "}
          <span style={{ textAlign: "center" }}>{counter}</span>
        </Row>
      )}
      <Row style={{ padding: "2%", paddingLeft: "1%" }}>
        <b>
          <p style={{ textAlign: "right", fontWeight: "bold" }}>
            {post.text_bottom}
          </p>
        </b>
      </Row>
      {modalIsOpen && userRole === "superadmin" && (
        <Col>
          <button className="btn btn-danger" onClick={() => deletePosts()}>
            Obriši
          </button>
        </Col>
      )}
      {modalIsOpen && (
        <div
          style={{ float: "right", paddingBottom: "2%", paddingRight: "1%" }}
        >
          <FacebookShareButton
            title="Facebook"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookShareButton>
          <span title="Viber">
            <ViberShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <ViberIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </ViberShareButton>
          </span>
          <EmailShareButton
            title="Email"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            subject="Check out this post"
          >
            <EmailIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </EmailShareButton>
          <FacebookMessengerShareButton
            title="Messenger"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookMessengerIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookMessengerShareButton>
          <span title="Telegram">
            <TelegramShareButton
              title="Telegram"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <TelegramIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </TelegramShareButton>
          </span>
          <span title="What's App">
            <WhatsappShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              title="Check out this post"
            >
              <WhatsappIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </WhatsappShareButton>
          </span>
        </div>
      )}
    </Container>
  );
}

export default MediumPoslednjiPozdrav;
